import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';

export interface ItemsResponse {
  ip: string;
}

// @Injectable()
// export class HttpBackendClient extends HttpClient {
//   constructor(handler: HttpBackend) {
//     super(handler);
//   }
// }

@Injectable()
export class AuthService {

  private accessToken: string;
  private ipAddress: string;
  constructor(private http: HttpClient) {
    this.ipAddress = '127.0.0.1';
  }

  setClientIp(ip: string) {
    this.ipAddress = ip;
  }

  getClientIp(): string {
    return this.ipAddress;
  }

  setAuthToken(token: string) {
    token !== null ? this.accessToken = token : this.accessToken = '';
  }

  getToken(): string {
    return this.accessToken;
  }

}




// WEBPACK FOOTER //
// ./src/app/core/services/auth/auth.service.ts